<h2>{{ 'DOCUMENTATION' | translate }}</h2>
<p [innerHTML]="'PLAYLIST_SOLR_HELPTEXT' | translate"></p>

<bb-table-local-filter></bb-table-local-filter>
<bb-table-container>
	<bb-table-header>
		<bb-table-header-cell property="label">{{ 'LABEL' | translate }}</bb-table-header-cell>
		<bb-table-header-cell property="type">{{ 'TYPE' | translate }}</bb-table-header-cell>
		<bb-table-header-cell property="value">{{ 'SOLR_KEY' | translate }}</bb-table-header-cell>
		<bb-table-header-cell property="description">{{ 'DESCRIPTION' | translate }}</bb-table-header-cell>
	</bb-table-header>
	<bb-table-row *ngFor="let row of this.solrFields">
		<bb-table-cell property="label" class="overflow">{{ row.data?.label | translate }}</bb-table-cell>
		<bb-table-cell property="type" class="overflow">{{ row.data?.type }}</bb-table-cell>
		<bb-table-cell property="value" class="overflow">{{ row.data?.value }}</bb-table-cell>
		<bb-table-cell property="description" class="overflow">{{ row.data?.description | translate }}</bb-table-cell>
	</bb-table-row>
</bb-table-container>
